// extracted by mini-css-extract-plugin
module.exports = {"info":"tweet-info_info__ZcXmZ","infoLink":"tweet-info_infoLink__g9__s","infoIcon":"tweet-info_infoIcon__e9k3x"};